import { useTranslation } from "react-i18next";
import ensorTower from "../../images/ensortower.webp";
import { useIsAuthenticated, useLogin } from "blitzware-react-sdk";

const Login = () => {
  const { t } = useTranslation();
  const isAuthenticated = useIsAuthenticated();
  const login = useLogin();

  if (isAuthenticated) {
    window.location.href = "/";
    return;
  } else {
    // Trigger external auth automatically
    login();
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center relative"
      style={{
        backgroundImage: `url(${ensorTower})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative w-full max-w-md mx-auto px-4">
        <div className="bg-white dark:bg-gray-900 rounded-lg p-8 shadow-xl">
          {/* Logo/Brand */}
          <div className="text-center mb-8">
            <div className="mx-auto w-12 h-12 bg-primary rounded-lg flex items-center justify-center mb-4">
              <span className="text-white text-xl font-bold">E</span>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              {t("auth.welcomeToEnsor")}
            </h1>
            <p className="text-gray-500 dark:text-gray-400 text-sm">
              Redirecting to authentication...
            </p>
          </div>

          {/* Loading spinner */}
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
